import * as React from 'react';
const SvgEngagingPatients = (props) => (
  <svg viewBox="0 0 116 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#engaging-patients_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinejoin="round">
      <path
        d="M91.678 93.75v16.875c0 4.144-3.35 7.5-7.484 7.5H24.323c-4.135 0-7.484-3.356-7.484-7.5V71.25M16.839 37.5V9.375c0-4.144 3.349-7.5 7.484-7.5h59.87c4.136 0 7.485 3.356 7.485 7.5V15"
        strokeLinecap="square"
      />
      <path
        d="M80.452 15v-1.875H28.064V33.75M28.064 75v20.625h52.388V93.75"
        strokeLinecap="square"
      />
      <path
        d="M46.774 106.875h14.968M1.871 48.75h5.613M18.71 48.75h20.58M7.484 60h5.613M24.323 60h20.58M76.71 26.25h18.71V45h18.709v18.75h-18.71V82.5H76.71V63.75H58V45h18.71V26.25Z"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="engaging-patients_svg__a">
        <path fill="#fff" d="M0 0h116v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEngagingPatients;
